export default {
  template: /* html */`
  <svg
    xmlns:dc="http://purl.org/dc/elements/1.1/"
    xmlns:cc="http://creativecommons.org/ns#"
    xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
    xmlns:svg="http://www.w3.org/2000/svg"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
    xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
    width="100"
    height="100"
    viewBox="0 0 26.458333 26.458333"
    version="1.1"
    id="svg2707"
    inkscape:version="0.92.5 (2060ec1f9f, 2020-04-08)"
    sodipodi:docname="blot.svg">
    <defs
      id="defs2701" />
    <sodipodi:namedview
      id="base"
      pagecolor="#ffffff"
      bordercolor="#666666"
      borderopacity="1.0"
      inkscape:pageopacity="0.0"
      inkscape:pageshadow="2"
      inkscape:zoom="3.1579063"
      inkscape:cx="116.25311"
      inkscape:cy="64.551163"
      inkscape:document-units="px"
      inkscape:current-layer="layer1"
      showgrid="false"
      units="px"
      inkscape:window-width="1920"
      inkscape:window-height="987"
      inkscape:window-x="0"
      inkscape:window-y="0"
      inkscape:window-maximized="1" />
    <metadata
      id="metadata2704">
      <rdf:RDF>
        <cc:Work
          rdf:about="">
          <dc:format>image/svg+xml</dc:format>
          <dc:type
            rdf:resource="http://purl.org/dc/dcmitype/StillImage" />
          <dc:title></dc:title>
        </cc:Work>
      </rdf:RDF>
    </metadata>
    <g
      inkscape:label="Layer 1"
      inkscape:groupmode="layer"
      id="layer1"
      transform="translate(0,-270.54167)">
      <path
        d="m 12.567662,273.8755 c 1.17608,2.75888 11.10481,-1.68243 8.797363,2.93246 -0.618301,1.2366 -3.43516,1.20737 -3.43516,2.42975 0,1.6945 8.922814,-1.08875 6.618968,3.51894 -1.518144,3.03629 -6.320813,0.45591 -8.043304,2.1784 -3.784814,3.78481 6.116263,3.67728 6.116263,7.95952 0,0.47997 0.07633,1.17671 -0.418923,1.42433 -5.322654,2.66133 -5.449588,-1.42433 -9.048716,-1.42433 -2.056064,0 -3.135191,3.74685 -5.1108494,2.42974 -2.2528313,-1.50188 -1.4164453,-4.3489 -3.1000231,-6.03247 -1.1920924,-1.1921 -3.3957827,0.83281 -4.44057403,-1.25677 -1.66094597,-3.32189 4.35958403,-4.2744 5.69734003,-4.94328 4.9000165,-2.45001 -6.3425589,-1.89337 -4.5243582,-5.52977 1.0379675,-2.07594 3.6030142,0.16743 4.7757116,-0.41892 2.3570845,-1.17855 -4.1350228,-5.69734 1.6756882,-5.69734 0.9176856,0 1.7541208,1.00541 2.6811009,1.00541 0.765215,0 1.480544,1.03383 1.759473,1.42433 z"
        id="path871"
        inkscape:connector-curvature="0" />
    </g>
  </svg>
  `
}